import sliceCreator from '../../index.jsx';
import {CREATE_CROP} from '../../../constants/index.jsx';
const _createCropAction = sliceCreator('CREATE_CROP', CREATE_CROP, 'post');

const { asyncAction: createCropAction, reducer, clearData: clearCreateCropAction } = _createCropAction;

export default reducer;

export {
    createCropAction,
    clearCreateCropAction
}